import { withStyles } from "@material-ui/core";
import React, {memo} from "react";
import { compose } from "recompose";
import styles from "./styles";
import MergeIcon from "@material-ui/icons/CallMerge";
import { isFuturePickup } from "../../../../filterUtils";
import { withUserProfile } from "../../../../../../../../userProfile/userProfileContext";
import { PICKUP_MANAGEMENT_MODES } from "../../../PickupManagement/constants";
import { withAppConfig } from "../../../../../../../../appConfigContext";
import StyledToolTip from "../../../../../../../common/StyledToolTip";
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';

class MergePickup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      enable: false,
      alreadyGrouped: false,
      showUnMergePickup: false,
    };
    this.selectedInvalidPickup = null;
  }

  componentDidMount() {
    this.props.eventHub.on(
      `${this.props.headerId}_updatePickupManagementIconStatus`,
      this.changeMergePickupStatus
    );
  }

  componentWillUnmount() {
    this.props.eventHub.off(
      `${this.props.headerId}_updatePickupManagementIconStatus`,
      this.changeMergePickupStatus
    );
  }

  allInSameGroup = (selectedPickups) => {
    if (selectedPickups.length < 2) return false;
    const firstGroupId = selectedPickups[0].groupId;
    return selectedPickups.every(p => p.groupId === firstGroupId);
  };

  changeMergePickupStatus = ({ selectedPickups, terminalOffset }) => {
    this.selectedInvalidPickup =selectedPickups.reduce((selectedInvalidPickup, pickup) => {
      if (selectedInvalidPickup) return selectedInvalidPickup;
      if (pickup.isCompleted) return 'Completed';
      if (pickup.isVoided) return 'Voided';
      if (pickup.isMissed) return 'Missed';
      if (isFuturePickup(
        pickup.pickupDate,
        terminalOffset
      )) return 'Future';
      if(pickup.rmaxPickupNumber && pickup.rmaxPickupNumber === pickup.pickupNumber) return 'RouteMax';
      return selectedInvalidPickup;
    }, null);
    const alreadyGrouped = this.allInSameGroup(selectedPickups);
    const isMergePickupEnabled = selectedPickups.length > 1 && !Boolean(this.selectedInvalidPickup) && !alreadyGrouped;
    const showUnMergePickup = this.props.configJSON.enableMergePickup && alreadyGrouped && this.selectedInvalidPickup !== 'Completed';
    this.setState({
      enable: isMergePickupEnabled,
      alreadyGrouped,
      showUnMergePickup,
    });
  };

  getTooltipMessage = () => {
    if (!this.props.configJSON.enableMergePickup) {
      return 'Merge pickups (Disabled)';
    } else if (this.selectedInvalidPickup) {
      return `${this.selectedInvalidPickup} pickup cannot be merged`
    } else if (this.state.enable) {
      return 'Click to merge pickups';
    } else if (this.state.alreadyGrouped) {
      return 'Already Grouped pickups cannot be merged';
    }
    return 'Select at least two pickups to merge';
  };

  onMergePickupEvent = () => {
    if (this.props.configJSON.enableMergePickup && this.state.enable) {
      this.props.eventHub.emit('pickupManagement', {
        action: PICKUP_MANAGEMENT_MODES.MERGE_PICKUP
      });
    }
  };

  onUnMergePickupEvent = () => {
    if (this.state.alreadyGrouped) {
      this.props.eventHub.emit('pickupManagement', {
        action: PICKUP_MANAGEMENT_MODES.UNGROUP_PICKUP
      });
    }
  };

  render() {
    const { classes } = this.props;
    const { showUnMergePickup } = this.state;
    return showUnMergePickup  ? (
      <div
        className={`${classes.headerIconStyles} ${classes.iconLayout} ${
          showUnMergePickup ? classes.enabledIcon : classes.disableIcon
        }`}
        onClick={this.onUnMergePickupEvent}>
        <StyledToolTip title={'Unmerge selected pickups'}>
          <RemoveCircleOutlineIcon />
        </StyledToolTip>
      </div>
    ) : (
      <div
        className={`${classes.headerIconStyles} ${classes.iconLayout} ${
          this.props.configJSON.enableMergePickup && this.state.enable ? classes.enabledIcon : classes.disableIcon
        }`}
        onClick={this.onMergePickupEvent}>
        <StyledToolTip title={this.getTooltipMessage()}>
          <MergeIcon />
        </StyledToolTip>
      </div>
    );
  }
}

export default compose(withUserProfile, withAppConfig, withStyles(styles))(memo(MergePickup));
